<!-- 区間 -->
<template>
  <div class="row">
    <div class="th cell">区間</div>
    <div class="cell">
      {{ from
      }}<img
        :src="require(`@/assets/img/icon/svg/icon-side-arrow.svg`)"
        class="arrow"
      />{{ to }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ViStationSection",
  props: {
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
